import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface ProjectStatusEntry {
  fullName: string;
  email: string;
  requestDate: number;
  startDate: number;
  fromStatus: string;
  toStatus: string;
}

export function useProjectStatus(projectId: string) {
  return useQuery<ProjectStatusEntry[]>({
    queryKey: ['projectStatus', projectId],
    queryFn: () => api.get<ProjectStatusEntry[]>(`/project/${projectId}/status`),
    enabled: !!projectId,
  });
}
